import { Alert } from '@mui/lab';
import styled from 'styled-components';

export const CustomAlert = styled(Alert)`
  .MuiAlert-message {
    width: 100%;
  }
`;
